import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "",
  width="19", 
  height="18.14", 
  viewBox="0 0 14.081 18.14"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Group_1" data-name="Group 1" transform="translate(-133.157 -51.296)">
        <path  fill={fill} id="Path_338" d="M195.4 56.995a5.7 5.7 0 0 0-11.4 0c0 3.147 5.7 9.787 5.7 9.787s5.7-6.64 5.7-9.787zm-7.961 0a2.262 2.262 0 1 1 2.262 2.262 2.262 2.262 0 0 1-2.264-2.262z" className="cls-1" data-name="Path 338" transform="translate(-49.502)"/>
        <path  fill={fill} id="Path_339" d="M144.931 548.36a11.69 11.69 0 0 0-1.456-.354.115.115 0 0 0-.113.046c-.226.312-.448.61-.658.888a.114.114 0 0 0 .075.182 11.306 11.306 0 0 1 1.785.394c1.213.386 1.461.784 1.461.869s-.248.483-1.461.869a14.846 14.846 0 0 1-4.21.57h-.311a14.843 14.843 0 0 1-4.21-.57c-1.213-.386-1.461-.784-1.461-.869s.248-.483 1.461-.869a11.3 11.3 0 0 1 1.784-.394.114.114 0 0 0 .075-.182 46.317 46.317 0 0 1-.658-.888.115.115 0 0 0-.113-.046 11.687 11.687 0 0 0-1.456.354c-1.053.335-2.307.958-2.307 2.025s1.255 1.691 2.307 2.026a18.146 18.146 0 0 0 9.466 0c1.052-.335 2.307-.958 2.307-2.026s-1.255-1.691-2.307-2.025z" className="cls-1" data-name="Path 339" transform="translate(0 -483.603)"/>
    </g>
  </svg>
);

export default SVG;



// WEBPACK FOOTER //
// ./src/components/UI/Icons/Location.js